import api from './request'

const vipUsers = (warehouseId) => {
    return api.getPromise('/package/vipUsers', {warehouseId})
}

const searchByKeyword = (platform, keyword, filter, day, teamId) => {
    //心选平台就是抖音平台
    if(platform * 1 === 2) {
        platform = 0 + ''
    }
    return api.getPromise('/package/searchByKeyword', {platform,
        keyword, filter, day, teamId})
}

const searchByProductKeyword = (keyword, teamId, platform) => {
    //心选平台就是抖音平台
    if(platform * 1 === 2) {
        platform = 0 + ''
    }
    return api.getPromise('package/searchByProductKeyword', {
        keyword, teamId, platform
    })
}

export default {
    vipUsers,
    searchByKeyword,
    searchByProductKeyword,
}


// WEBPACK FOOTER //
// ./src/request/packagedApi.js